import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import Guard from "../../guard";
import { PropertyData } from "./property-data";
import { RelationData } from "./relation-data";

@JsonObject()
export class MinimalSchema {
    @JsonProperty("definition_name")
    definitionName: string;

    @JsonProperty("properties")
    @JsonElementType(PropertyData)
    properties: Array<PropertyData>;

    @JsonProperty("relations")
    @JsonElementType(RelationData)
    relations: Array<RelationData>;

    constructor(name?: string) {
        if (name != null) {
            Guard.stringNotNullOrEmpty(name);
            this.definitionName = name;
        }

        this.properties = [];
        this.relations = [];
    }
}
